module.exports = __webpack_public_path__ + "img/15.60da4ca9.jpg";